import { pathFilterNames } from '../../../../redux/products/types';

export const INDEXABLE_PATH_FILTERS_SUM_UPPER_LIMIT = 4;
export const INDEXABLE_PAGE_MULTIPLE_FILTERS_UPPER_LIMIT = 1;
export const INDEXABLE_FILTER_SELECTION_LIMIT = 1;
export const BREADCRUMBS_PATH_FILTERS_UPPER_LIMIT = 1;
export const BRAND_CATEGORIES_FILTER_LENGTH_FOR_OTHER_ACTIVE = 1;

export const SEO_CONSTANTS = {
    alternateKeyLink: 'alternate',
    canonicalKeyLink: 'canonical',
    nextRelKeyLink: 'next',
    prevRelKeyLink: 'prev',
    indexable: 'index,follow',
    noIndexable: 'noindex,nofollow',
    robotsMetaName: 'robots',
    descriptionMetaName: 'description',
    breadcrumbListType: 'BreadcrumbList',
    ogImageUrl: 'og:image:url',
    ogImageSecureUrl: 'og:image:secure_url',
    ogType: 'og:type',
    ogLocale: 'og:locale',
    ogSiteName: 'og:site_name',
    ogTitle: 'og:title',
    ogDescription: 'og:description',
    ogUrl: 'og:url',
    ogTypeContentValue: 'product',
    ogTypeHomeContentValue: 'website',
    siteName: 'WestwingNow',
    structureDataAvailibilityValue: 'http://schema.org/InStock',
    structureDataContextKey: '@context',
    structureDataContextValue: 'https://schema.org',
    structureDataScriptType: 'application/ld+json',
    structureDataTypeAggregateRating: 'AggregateRating',
    structureDataTypeAuthor: 'Person',
    structureDataTypeKey: '@type',
    structureDataTypeListItem: 'ListItem',
    structureDataTypeOffer: 'Offer',
    structureDataTypeProduct: 'Product',
    structureDataTypeRating: 'Rating',
    structureDataTypeReview: 'Review',
};

export const BREAD_CRUMB_FILTER_WHITELIST: string[] = [
    pathFilterNames.styles,
    pathFilterNames.colors,
    pathFilterNames.materials,
];
